export const GET_FUEL_PROVIDER_REFERENCES = 'GET_FUEL_PROVIDER_REFERENCES';
export const GET_FUEL_PROVIDER_PARTNER_REFERENCES = 'GET_FUEL_PROVIDER_PARTNER_REFERENCES';
export const GET_FUEL_TYPES_REFERENCES = 'GET_FUEL_TYPES_REFERENCES';
export const GET_REGIONS_REFERENCES = 'GET_REGIONS_REFERENCES';
export const GET_FUEL_PROVIDER_PARTNERS_AZS_REFERENCES = 'GET_FUEL_PROVIDER_PARTNERS_AZS_REFERENCES';
export const GET_GOLD_AZS_REFERENCES = 'GET_GOLD_AZS_REFERENCES';
export const GET_STATION_COORDINATES = 'GET_STATION_COORDINATES';
export const GET_ROUTE_PLANNER_FAVORITES = 'GET_ROUTE_PLANNER_FAVORITES';
